function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMa = function SvgMa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-900 0H0v600h-900z",
    style: {
      fill: "#c1272d",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450 224.315-44.467 136.87 116.401-84.559h-143.87l116.403 84.559z",
    style: {
      fill: "none",
      stroke: "#006233",
      strokeWidth: 14.62993431,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }));
};
export default SvgMa;